export default __webpack_public_path__ + "static/media/image.f5a3d29d.png";